module.exports = __webpack_public_path__ + "img/zbanner3-min.b8b6e4e3.jpg";